<div>
<h1>Projecten</h1>
@for(project of projects; track $index) {
    <h3>{{project.title}}</h3>
    <dynamic-template *ngIf="project" [content]="project.innerHtml"></dynamic-template>
    <hr *ngIf="projects.length > 1" class="hr-ebemGreen" />
}    
</div>